export default {
  text: 'Verifica con {{provider}}',
  text_generic: 'Verifica con il tuo fornitore di pagamenti',
  error: 'Non è stato possibile aprire il modulo {{provider}}. Riprova.',
  error_generic: 'Non è stato possibile aprire il modulo del fornitore di pagamenti. Riprova.',
  providers: {
    stripe: 'Stripe',
    adyen: 'Adyen',
  },
};
